<glxy-page>
  <glxy-page-toolbar [showExtendedToolbar]="true">
    <glxy-page-title>{{ 'LEADERBOARD.TITLE' | translate }}</glxy-page-title>
    <glxy-page-extended-toolbar>
      <crm-date-range-selector (dateRangeChanged)="onDateChange($event)"></crm-date-range-selector>
    </glxy-page-extended-toolbar>
  </glxy-page-toolbar>
  <crm-activity-leaderboard [selection]="selection$ | async"></crm-activity-leaderboard>
</glxy-page>
